// compressImageToMaxSize.js
// Compresses an image blob to be under maxSizeBytes using JPEG quality + optional downscale.
const createImage = (blob) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(blob);
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (err) => {
      URL.revokeObjectURL(url);
      reject(err);
    };
    img.src = url;
  });

const canvasToBlob = (canvas, quality) =>
  new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) return reject(new Error("Compression failed"));
        resolve(blob);
      },
      "image/jpeg",
      quality
    );
  });

export default async function compressImageToMaxSize(blob, maxSizeBytes) {
  if (!blob || blob.size <= maxSizeBytes) return blob;

  const image = await createImage(blob);
  let scale = 1;
  let quality = 0.9;

  for (let attempt = 0; attempt < 8; attempt += 1) {
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.floor(image.naturalWidth * scale));
    canvas.height = Math.max(1, Math.floor(image.naturalHeight * scale));
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

    const candidate = await canvasToBlob(canvas, quality);
    if (candidate.size <= maxSizeBytes) return candidate;

    // Reduce quality first, then scale down if needed
    if (quality > 0.5) {
      quality -= 0.1;
    } else {
      scale *= 0.85;
    }
  }

  return blob;
}
